| u8g2_SetBitmapMode(&u8g2, 1);
| u8g2_SetFontMode(&u8g2, 1);
|
each decl in declarations 
    | !{decl}
    |
if settings.wrap
    | void draw(void) {
each layer in layers 
    case layer.type
        when 'dot'
            | @!{layer.id};u8g2_DrawPixel(&u8g2, !{layer.x}, !{layer.y});
        when 'line'
            | @!{layer.id};u8g2_DrawLine(&u8g2, !{layer.x1}, !{layer.y1}, !{layer.x2}, !{layer.y2});
        when 'rect'
            - var func = layer.fill ? 'DrawBox' : 'DrawFrame'
            | @!{layer.id};u8g2_!{func}(&u8g2, !{layer.x}, !{layer.y}, !{layer.w}, !{layer.h});
        when 'circle'
            - var func = layer.fill ? 'DrawDisc' : 'DrawCircle'
            | @!{layer.id};u8g2_!{func}(&u8g2, !{layer.x}, !{layer.y}, !{layer.r});
        when 'ellipse'
            - var func = layer.fill ? 'FillEllipse' : 'DrawEllipse'
            | @!{layer.id};u8g2_!{func}(&u8g2, !{layer.x}, !{layer.y}, !{layer.rx}, !{layer.ry});
        when 'string'
            | u8g2_setFont(&u8g2, u8g2_font_!{layer.font});
            | @!{layer.id};u8g2_DrawStr(&u8g2, !{layer.x}, !{layer.y}, "!{layer.text}");
        when 'paint'
        when 'icon'
            | @!{layer.id};u8g2_DrawXBM(&u8g2, !{layer.x}, !{layer.y}, !{layer.w}, !{layer.h}, !{layer.imageName});
        default 
            |
            | // Unknown layer type !{layer.type}
    |
    |
if settings.wrap
    | }